<template>
    <div id="modal_position">
        <v-layout id="modal" row wrap align-center justify-center>
            <div id="modal_background" @click="$emit('close')" />
            <v-flex xs0 sm1 md2 lg3 />
            <v-flex id="modal_card" xs12 sm10 md8 lg6 @keyup.esc="$emit('close')">
                <header class="modal-card-head">
                    <div class="modal-card-title">
                        <slot name="header_title" />
                    </div>
                    <button class="delete" aria-label="close" @click="$emit('close')" />
                </header>
                <div :class="bodyNoFooter ? 'body-no-footer' : ''" class="modal-card-body">
                    <slot name="main" />
                </div>
                <footer class="modal-card-foot">
                    <slot name="footer" />
                </footer>
            </v-flex>
            <v-flex xs0 sm1 md2 lg3 />
        </v-layout>
    </div>
</template>

<script>
    import { VLayout, VFlex } from 'vuetify/es5/components/VGrid';

    export default {
        name: 'Modal',
        components: { VLayout, VFlex },
        data () {
            return {
                bodyNoFooter: false
            };
        },
        mounted () {
            let element = this.$el.querySelector('footer');
            this.bodyNoFooter = !this.$slots.footer;
            if (this.bodyNoFooter) {
                element.parentNode.removeChild(element);
            }
        }
    };
</script>

<style lang="scss" scoped>
    #modal_position {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 40;
    }

    #modal {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        height: 100%;
        width: 100%;
        margin: 0;
    }

    #modal_background {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background-color: #393E46;
        opacity: 0.9;
        z-index: 10;
    }

    #modal_card {
        z-index: 15;
        max-height: 90%;
    }

    .modal-card-head {
        border-bottom: 1px solid #dbdbdb;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        background-color: #f5f5f5;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        flex-shrink: 0;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        padding: 20px;
        position: relative;
    }

    .modal-card-title {
        text-align: center;
        color: #363636;
        -webkit-box-flex: 1;
        flex-grow: 1;
        flex-shrink: 0;
        font-size: 1.5rem;
        line-height: 1;
    }

    .modal-card-body {
        padding: 0;
        -webkit-overflow-scrolling: touch;
        background-color: #fff;
        -webkit-box-flex: 1;
        flex-grow: 1;
        flex-shrink: 1;
        overflow: auto;
    }

    .modal-card-body.body-no-footer {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    .modal-card-foot {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        border-top: 1px solid #dbdbdb;
        align-items: center;
        background-color: #f5f5f5;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        flex-shrink: 0;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        padding: 20px;
        position: relative;
    }

    .help.is-danger {
        color: #ff3860;
    }

    .help {
        display: block;
        font-size: .75rem;
        margin-top: .25rem;
    }

    .delete {
        -moz-appearance: none;
        -webkit-appearance: none;
        background-color: rgba(10, 10, 10, .2);
        border: none;
        border-radius: 290486px;
        cursor: pointer;
        pointer-events: auto;
        display: inline-block;
        -webkit-box-flex: 0;
        flex-grow: 0;
        flex-shrink: 0;
        font-size: 0;
        height: 20px;
        max-height: 20px;
        max-width: 20px;
        min-height: 20px;
        min-width: 20px;
        outline: none;
        position: relative;
        vertical-align: top;
        width: 20px;
    }

    .delete:before, .modal-close:before,
    .delete:after, .modal-close:after {
        background-color: #fff;
        content: "";
        display: block;
        left: 50%;
        position: absolute;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
        transform: translateX(-50%) translateY(-50%) rotate(45deg);
        -webkit-transform-origin: center center;
        transform-origin: center center;
    }

    .delete:before, .modal-close:before {
        height: 2px;
        width: 50%;
    }

    .delete:after, .modal-close:after {
        height: 50%;
        width: 2px;
    }
</style>
